import React, { useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const pitchOptions = ['A story', 'A community problem', 'A forum / panel idea', 'A documentary subject', 'Something else'];
const inputCls = 'w-full rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-sm text-[#e7e9ee] placeholder:text-[#e7e9ee]/40 outline-none transition-colors focus:border-[#e8743b]';
const labelCls = 'mb-2 block text-xs font-semibold uppercase tracking-wide text-[#e7e9ee]/55';

const PitchForm = ({ onSubmit }) => {
  const [form, setForm] = useState({ name: '', email: '', role: '', type: 'A story', story: '' });
  const [loading, setLoading] = useState(false);
  const onChange = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.story) {
      onSubmit({ ok: false, message: 'Please complete the required fields.' });
      return;
    }
    setLoading(true);
    try {
      const story = form.role ? `[${form.role}] ${form.story}` : form.story;
      await axios.post(`${API}/pitch`, { name: form.name, email: form.email, type: form.type, story });
      onSubmit({ ok: true });
      setForm({ name: '', email: '', role: '', type: 'A story', story: '' });
    } catch (err) {
      const detail = err?.response?.data?.detail || 'Something went wrong. Please try again.';
      onSubmit({ ok: false, message: typeof detail === 'string' ? detail : 'Please check your details.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="rounded-3xl border border-white/10 bg-[#111726] p-6 sm:p-8">
      <form onSubmit={submit} className="space-y-5">
        <div className="grid gap-5 sm:grid-cols-2">
          <label className="block">
            <span className={labelCls}>Your name</span>
            <input required placeholder="First and last name" className={inputCls} value={form.name} onChange={onChange('name')} />
          </label>
          <label className="block">
            <span className={labelCls}>Email</span>
            <input required type="email" placeholder="you@example.com" className={inputCls} value={form.email} onChange={onChange('email')} />
          </label>
        </div>
        <label className="block">
          <span className={labelCls}>What do you do? (optional)</span>
          <input placeholder="e.g. community worker, student, artist, lawyer…" className={inputCls} value={form.role} onChange={onChange('role')} />
        </label>
        <label className="block">
          <span className={labelCls}>What are you pitching?</span>
          <select className={inputCls} value={form.type} onChange={onChange('type')}>
            {pitchOptions.map((o) => (
              <option key={o} value={o} className="bg-[#0a0e16]">{o}</option>
            ))}
          </select>
        </label>
        <label className="block">
          <span className={labelCls}>Tell us about your idea</span>
          <textarea required rows={5} placeholder="A few lines is plenty - what's the story, who is it about, and why does it matter to the community?" className={`${inputCls} resize-y`} value={form.story} onChange={onChange('story')} />
        </label>
        <button type="submit" disabled={loading} className="w-full rounded-full bg-[#e8743b] px-7 py-3.5 text-sm font-semibold text-white transition-transform duration-150 hover:brightness-105 active:scale-[0.97] disabled:opacity-60">
          {loading ? 'Sending…' : 'Pitch your story'}
        </button>
        <p className="text-center text-xs text-[#e7e9ee]/45">
          We read every single application and reply personally within a few working days.
        </p>
      </form>
    </div>
  );
};

export default PitchForm;
